<template>
  <v-card class="px-3 py-5" outlined>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12" lg="6" xl="6" class="d-flex align-center justify-center mb-3">
          <h2 class="mr-3 mt-n7">Choose a tournament</h2>
          <v-select :items="tournaments" item-text="name" item-value="id" @change="tournamentsChanged" v-model="tournamentSelected" outlined/>
        </v-col>
      </v-row>
      <v-row>
        <v-data-table :headers="headers" :items="participants" style="width: 100%">
          <template v-slot:item.rank="{ item }">
            <h4>{{ getRank(item) + 1 }}</h4>
          </template>
          <template v-slot:item.image="{ item }">
            <v-avatar size="30">
              <v-img :src="item.profilePicture !== null? item.profilePicture : 'https://swiset.com/wp-content/uploads/2019/12/Responsive.jpg'" contain></v-img>
            </v-avatar>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip color="primary" small outlined><p style="font-size: 15px!important;" class="mb-0">{{ capitalize(item.status) }}</p></v-chip>
          </template>
          <template v-slot:item.score="{ item }">
            <v-chip color="primary" small><b style="color: #ffffff">{{ (item.score != null)? item.score.toFixed(2) : '-' }}</b></v-chip>
          </template>
        </v-data-table>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/helpDesk';

export default {
  name: "TournamentParticipants",
  data() {
    return {
      tournaments: [],
      tournamentSelected: 0,
      participants: [],
      headers: [
        {text: 'Rank', align: 'left', value: 'rank', sortable: true},
        {text: 'Profile', align: 'left', value: 'image', sortable: false},
        {text: 'First Name', align: 'left', value: 'firstName', sortable: false},
        {text: 'Last Name', align: 'left', value: 'lastName', sortable: false},
        {text: 'Username', align: 'left', value: 'username', sortable: false},
        {text: 'Status', align: 'left', value: 'status', sortable: false},
        {text: 'Score', value: 'score', sortable: false},
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getTournaments();
    },
    getTournaments() {
      Repository.getTournaments().then((response) => {
        if (response.status < 400) {
          this.tournaments = response.data;
          this.tournamentSelected = this.tournaments[this.tournaments.length - 1].id;
          this.tournamentsChanged();
        }
      });
    },
    tournamentsChanged() {
      Repository.getTournamentOverview(this.tournamentSelected).then((response) => {
        if (response.status < 400) {
          this.participants = response.data.participants;
        }
      });
    },
    getRank(participant) {
      return this.participants.indexOf(participant);
    },
    isWinning(participant) {
      return (participant.participantId === this.participants[0].participantId) ? 1 :
          (participant.participantId === this.participants[1].participantId) ? 2 :
              (participant.participantId === this.participants[2].participantId) ? 3 : -1;
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
  }
}
</script>

<style scoped>

</style>
